module.exports = __webpack_public_path__ + "img/icon-success.86ef8b13.png";